import type { SvgIconComponent } from '@mui/icons-material';
import ApartmentOutlined from '@mui/icons-material/ApartmentOutlined';
import AssessmentOutlined from '@mui/icons-material/AssessmentOutlined';
import BarChartOutlined from '@mui/icons-material/BarChartOutlined';
import BoltOutlined from '@mui/icons-material/BoltOutlined';
import CalendarMonthOutlined from '@mui/icons-material/CalendarMonthOutlined';
import CategoryOutlined from '@mui/icons-material/CategoryOutlined';
import Co2Outlined from '@mui/icons-material/Co2Outlined';
import CompareArrowsOutlined from '@mui/icons-material/CompareArrowsOutlined';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import DoNotDisturbOnOutlined from '@mui/icons-material/DoNotDisturbOnOutlined';
import DonutLargeOutlined from '@mui/icons-material/DonutLargeOutlined';
import ElectricMeterOutlined from '@mui/icons-material/ElectricMeterOutlined';
import EnergySavingsLeafOutlined from '@mui/icons-material/EnergySavingsLeafOutlined';
import FactCheckOutlined from '@mui/icons-material/FactCheckOutlined';
import FactoryOutlined from '@mui/icons-material/FactoryOutlined';
import FileDownloadOutlined from '@mui/icons-material/FileDownloadOutlined';
import FlagOutlined from '@mui/icons-material/FlagOutlined';
import HealthAndSafetyOutlined from '@mui/icons-material/HealthAndSafetyOutlined';
import GroupsOutlined from '@mui/icons-material/GroupsOutlined';
import HubOutlined from '@mui/icons-material/HubOutlined';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import InsightsOutlined from '@mui/icons-material/InsightsOutlined';
import LocalFireDepartmentOutlined from '@mui/icons-material/LocalFireDepartmentOutlined';
import LocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined';
import LocationOnOutlined from '@mui/icons-material/LocationOnOutlined';
import OilBarrelOutlined from '@mui/icons-material/OilBarrelOutlined';
import PaymentsOutlined from '@mui/icons-material/PaymentsOutlined';
import PropaneTankOutlined from '@mui/icons-material/PropaneTankOutlined';
import PublicOutlined from '@mui/icons-material/PublicOutlined';
import RecyclingOutlined from '@mui/icons-material/RecyclingOutlined';
import RuleOutlined from '@mui/icons-material/RuleOutlined';
import ScaleOutlined from '@mui/icons-material/ScaleOutlined';
import SchoolOutlined from '@mui/icons-material/SchoolOutlined';
import SensorsOutlined from '@mui/icons-material/SensorsOutlined';
import SpeedOutlined from '@mui/icons-material/SpeedOutlined';
import TaskAltOutlined from '@mui/icons-material/TaskAltOutlined';
import TimelineOutlined from '@mui/icons-material/TimelineOutlined';
import TuneOutlined from '@mui/icons-material/TuneOutlined';
import VerifiedOutlined from '@mui/icons-material/VerifiedOutlined';
import WaterDropOutlined from '@mui/icons-material/WaterDropOutlined';

/**
 * Semantic icon map for the ESG content area — one Outlined family, one icon
 * per concept. Import from here instead of picking icons ad hoc so the same
 * metric never shows two different glyphs. (Sidebar icons live in Layout.)
 */
export const ESG_ICONS = {
  // Environmental
  wasteCollected: RecyclingOutlined,
  completionRate: TaskAltOutlined,
  avoidedEmissions: EnergySavingsLeafOutlined,
  co2: Co2Outlined,
  mass: ScaleOutlined,
  energySavings: ElectricMeterOutlined,
  materialFlows: DonutLargeOutlined,
  materials: CategoryOutlined,

  // GHG inventory
  ghgInventory: FactoryOutlined,
  scope1: LocalFireDepartmentOutlined,
  scope2: BoltOutlined,
  scope3: PublicOutlined,

  // Resource use
  water: WaterDropOutlined,
  electricity: BoltOutlined,
  oil: OilBarrelOutlined,
  gas: PropaneTankOutlined,
  cost: PaymentsOutlined,

  // Social / operations
  fillReports: SensorsOutlined,
  training: SchoolOutlined,
  social: GroupsOutlined,
  healthSafety: HealthAndSafetyOutlined,
  operations: LocalShippingOutlined,
  efficiency: SpeedOutlined,
  branches: ApartmentOutlined,
  site: LocationOnOutlined,

  // Data / reporting
  timeSeries: TimelineOutlined,
  chart: BarChartOutlined,
  insights: InsightsOutlined,
  methodology: FactCheckOutlined,
  dataQuality: RuleOutlined,
  verification: VerifiedOutlined,
  traceability: HubOutlined,
  targets: FlagOutlined,
  runsCompleted: TaskAltOutlined,
  runsExcluded: DoNotDisturbOnOutlined,
  report: DescriptionOutlined,
  reports: AssessmentOutlined,

  // Actions / context
  period: CalendarMonthOutlined,
  download: FileDownloadOutlined,
  compare: CompareArrowsOutlined,
  customize: TuneOutlined,
  info: InfoOutlined,
} satisfies Record<string, SvgIconComponent>;

export type EsgIconKey = keyof typeof ESG_ICONS;
